import {
    ORCHESTRATOR_PRODUCT_CHAT_FLAG_NAME,
    readFlagBoolean,
} from '@apps/web/lib/admin_flags';
import { useAdminFlags } from '@apps/web/swr_data_fetching/data_fetching_hooks';

/** Whether this viewer may start and open orchestrator chats. */
export function useOrchestratorProductChatEnabled(
    viewerIsAdmin: boolean,
): boolean {
    const { data: adminFlags } = useAdminFlags(viewerIsAdmin);
    return (
        viewerIsAdmin &&
        readFlagBoolean(
            adminFlags?.find(
                (flag) => flag.name === ORCHESTRATOR_PRODUCT_CHAT_FLAG_NAME,
            ),
        )
    );
}
